import axios, { AxiosInstance } from "axios";

let isTesting = process.env.REACT_APP_TESTING == "1";
let env = process.env.NODE_ENV;

export class Environment {
    static get isTesting() {
        return isTesting;
    }

    static get isDev() {
        return env == "development";
    }

    static environmentName() {
        let env: string = window?.sessionStorage["environment"] ?? "https://testing.carsharing.yandex.net"
        if (env.startsWith("https://testing")) {
            return env.includes("backend_cluster=qa") ? "qa" : "testing";
        } else if (env.startsWith("https://prestable")) {
            return "prestable";
        } else if (env.startsWith("https://stable")) {
            return "stable";
        }
        return "unknown";
    }

    static setEnvironmentFromName(name: string) {
        if (name == "qa") {
            window.sessionStorage["environment"] = "https://testing.carsharing.yandex.net?backend_cluster=qa";
        } else if (name == "testing") {
            window.sessionStorage["environment"] = "https://testing.carsharing.yandex.net";
        } else if (name == "prestable") {
            window.sessionStorage["environment"] = "https://prestable.carsharing.yandex.net";
        } else if (name == "stable") {
            window.sessionStorage["environment"] = "https://stable.carsharing.yandex.net";
        }
    }

    static getBaseUrl() {
        if (env == "development") {
            let url = new URL(window?.sessionStorage["environment"] ?? "https://testing.carsharing.yandex.net");
            return url.origin;
        } else {
            let baseUrl = (window.location.origin + window.location.pathname + "/saas");
            return baseUrl;
        }
    }

    static getHeaders() {
        if (isTesting || env == "development") {
            let url = new URL(window?.sessionStorage["environment"] ?? "https://testing.carsharing.yandex.net");
            return {
                "saas": url.origin
            };
        } else {
            return {
                "saas": "https://stable.carsharing.yandex.net"
            };
        }
    }

    static getParams(): URLSearchParams | null {
        if (isTesting || env == "development") {
            let url = new URL(window?.sessionStorage["environment"] ?? "https://testing.carsharing.yandex.net");
            return url.searchParams;
        } else {
            return null;
        }
    }
}

export const instance = createInstance();

function createInstance() {
    const instance = axios.create({
        baseURL: Environment.getBaseUrl(),
        headers: Environment.getHeaders()
    });

    instance.interceptors.request.use((config) => {
        const params = Environment.getParams();
        if (config.params) {
            params?.forEach((value, key) => {
                config.params.set(key, value);
            })    
        } else {
            config.params = params;
        }
        return config;
    });
    return instance;
}